var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.197,
    height: 113.975,
    viewBox: "0 0 96.197 113.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16",
    "data-name": "Grupo 16",
    transform: "translate(-226 -438.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26",
    "data-name": "Trazado 26",
    d: "M53.543,41.251A20.816,20.816,0,1,0,74.36,62.067,20.816,20.816,0,0,0,53.543,41.251M39.666,62.067A13.877,13.877,0,1,1,53.543,75.944,13.877,13.877,0,0,1,39.666,62.067",
    transform: "translate(221.077 423.795)",
    fill: "#314164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27",
    "data-name": "Trazado 27",
    d: "M53.393,83.582A21.665,21.665,0,1,1,75.058,61.917,21.688,21.688,0,0,1,53.393,83.582m0-41.631A19.966,19.966,0,1,0,73.359,61.917,19.988,19.988,0,0,0,53.393,41.951m0,34.692A14.727,14.727,0,1,1,68.12,61.917,14.742,14.742,0,0,1,53.393,76.644m0-27.754A13.027,13.027,0,1,0,66.421,61.917,13.041,13.041,0,0,0,53.393,48.89",
    transform: "translate(221.227 423.945)",
    fill: "#314164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_28",
    "data-name": "Trazado 28",
    d: "M53.393,83.582A21.665,21.665,0,1,1,75.058,61.917,21.688,21.688,0,0,1,53.393,83.582m0-41.631A19.966,19.966,0,1,0,73.359,61.917,19.988,19.988,0,0,0,53.393,41.951m0,34.692A14.727,14.727,0,1,1,68.12,61.917,14.742,14.742,0,0,1,53.393,76.644m0-27.754A13.027,13.027,0,1,0,66.421,61.917,13.041,13.041,0,0,0,53.393,48.89",
    transform: "translate(221.227 423.945)",
    fill: "#314164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_29",
    "data-name": "Trazado 29",
    d: "M53.243,84.281A22.515,22.515,0,1,1,75.757,61.767,22.539,22.539,0,0,1,53.243,84.281M32.428,61.767a20.815,20.815,0,1,0,41.63,0,20.815,20.815,0,1,1-41.63,0M53.243,42.65A19.116,19.116,0,1,0,72.359,61.767,19.137,19.137,0,0,0,53.243,42.65m0,34.692A15.576,15.576,0,1,1,68.819,61.767,15.593,15.593,0,0,1,53.243,77.343M39.367,61.767a13.877,13.877,0,1,0,27.753,0,13.877,13.877,0,1,1-27.753,0M53.243,49.589A12.178,12.178,0,1,0,65.421,61.767,12.191,12.191,0,0,0,53.243,49.589",
    transform: "translate(221.378 424.096)",
    fill: "#314164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30",
    "data-name": "Trazado 30",
    d: "M15.59,91.771a46.4,46.4,0,1,1,65.619,0L50.853,122.125a3.467,3.467,0,0,1-4.906,0ZM20.5,31.058a39.46,39.46,0,0,0,0,55.805l27.9,27.9,27.9-27.9A39.46,39.46,0,0,0,20.494,31.058Z",
    transform: "translate(225.699 428.11)",
    fill: "#314164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31",
    "data-name": "Trazado 31",
    d: "M48.249,123.84a4.306,4.306,0,0,1-3.053-1.263L14.839,92.222A47.248,47.248,0,1,1,81.659,25.4a47.247,47.247,0,0,1,0,66.818L51.3,122.576a4.306,4.306,0,0,1-3.054,1.263M16.04,91.02,46.4,121.375a2.623,2.623,0,0,0,3.7,0L80.457,91.02A45.549,45.549,0,1,0,16.04,26.6a45.549,45.549,0,0,0,0,64.416m32.207,24.8-28.5-28.5a40.361,40.361,0,0,1-1.381-55.556h-.071l1.45-1.45A40.31,40.31,0,0,1,76.75,87.315ZM21.166,31.289l-.22.22a38.611,38.611,0,0,0,0,54.6l27.3,27.3,27.3-27.3A38.611,38.611,0,0,0,21.166,31.289",
    transform: "translate(225.85 428.26)",
    fill: "#314164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_32",
    "data-name": "Trazado 32",
    d: "M48.249,123.84a4.306,4.306,0,0,1-3.053-1.263L14.839,92.222A47.248,47.248,0,1,1,81.659,25.4a47.247,47.247,0,0,1,0,66.818L51.3,122.576a4.306,4.306,0,0,1-3.054,1.263M16.04,91.02,46.4,121.375a2.623,2.623,0,0,0,3.7,0L80.457,91.02A45.549,45.549,0,1,0,16.04,26.6a45.549,45.549,0,0,0,0,64.416m32.207,24.8-28.5-28.5a40.361,40.361,0,0,1-1.381-55.556h-.071l1.45-1.45A40.31,40.31,0,0,1,76.75,87.315ZM21.166,31.289l-.22.22a38.611,38.611,0,0,0,0,54.6l27.3,27.3,27.3-27.3A38.611,38.611,0,0,0,21.166,31.289",
    transform: "translate(225.85 428.26)",
    fill: "#314164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_33",
    "data-name": "Trazado 33",
    d: "M48.1,124.538a5.134,5.134,0,0,1-3.655-1.512L14.088,92.671a48.1,48.1,0,1,1,68.021-68.02,48.094,48.094,0,0,1,0,68.02L51.754,123.025a5.134,5.134,0,0,1-3.655,1.512M16.49,90.268l30.357,30.354a1.816,1.816,0,0,0,2.5,0L79.706,90.268A44.7,44.7,0,1,0,16.49,27.054a44.7,44.7,0,0,0,0,63.214M1.7,58.66A46.064,46.064,0,0,0,13.824,89.938,46.07,46.07,0,0,1,1.7,58.66M88.16,35.216A46.112,46.112,0,0,1,94.5,58.662,46.11,46.11,0,0,0,88.16,35.216M7.153,36.789A46.157,46.157,0,0,0,1.7,58.66,46.157,46.157,0,0,1,7.153,36.789m81.006-1.578v0M71.318,18.467l0,0,0,0M48.1,12.262a46.125,46.125,0,0,1,23.217,6.2,46.125,46.125,0,0,0-23.217-6.2m0,0a46.16,46.16,0,0,0-22.241,5.653A46.162,46.162,0,0,1,48.1,12.262m0,104.606-29.1-29.1a41.113,41.113,0,0,1-2.64-55.308h-.191l1.379-1.45,1.45-1.45A41.16,41.16,0,0,1,77.2,87.765ZM21.615,31.741l-.217.217a37.76,37.76,0,0,0,0,53.4l26.7,26.7,26.7-26.7a37.761,37.761,0,0,0-53.183-53.62M11.171,44.69A39.493,39.493,0,0,0,10.2,69.715a39.838,39.838,0,0,1,.972-25.024m8.089-13-.4.469q.65-.715,1.338-1.4l.224-.224A39.22,39.22,0,0,1,48.066,19.2,39.2,39.2,0,0,0,20.194,30.757ZM48.082,19.2h0Z",
    transform: "translate(226 428.411)",
    fill: "#314164"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.37f9ea20e1a21821ce5e1b1246547b70.svg";
export { ForwardRef as ReactComponent };